/**
 * Terminal END node for the automation flow.
 */
export function EndNode() {
  return (
    <div className="flex justify-center">
      <div className="px-5 py-1.5 rounded-full bg-wt-bg-secondary border border-wt-border-subtle text-[10px] font-semibold uppercase tracking-widest text-wt-text-disabled">
        END
      </div>
    </div>
  );
}
